import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Plus(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9954 17.0012V7.00117M16.9954 12.0012H6.99536" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </SvgIcon>
  );
}
